import React, { useEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { getFeatureManagementAsync, setValuesfeatureManagementList, addFeatureManagementAsync, checkedState, unCheckedState } from "./featureManagementSlice";
import HolidayTypeOffCanvas from '../../../common/OffCanvas';
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers';
import { ShowToast } from "../../../common/Toastr";
import { ShowSwal, ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { original } from "@reduxjs/toolkit";
import { useTranslation } from "react-i18next";
import './FeatureManagement.css'
import Loader from "../../../common/Loader";
import { getValueFromResource } from "../../../common/timeLiveFunction";
const FeatureManagement = () => {
  const dispatch = useAppDispatch();
  const modelRef = useRef<any>(null);
  const { featureManagementList, isReload, selectedRecord, isLoading, featureList } = useAppSelector((state) => state.featureManagement);
  const [isChecked, setIsChecked] = useState(false);
  const { t } = useTranslation();


  useEffect(() => {
    // if (isReload) {
    dispatch(getFeatureManagementAsync());
    // }
  }, [isReload])
  useEffect(() => {
    dispatch(getFeatureManagementAsync());
  }, [dispatch])

  const handleOnClickEvent = () => {

    dispatch(addFeatureManagementAsync(featureManagementList))
      .unwrap()
      .then((originalPromiseResult) => {
        ShowToast(originalPromiseResult.message, 'Success', "success", "toast-top-right");
      })
      .catch((rejectedValueOrSerializedError) => {
        ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
      })
  }

  const handleChange = (e: any, SystemFeatureId: string, FieldName: string) => {
    if (e.target.checked) {
      dispatch(checkedState(SystemFeatureId))
    } else {
      dispatch(unCheckedState(SystemFeatureId))
    }
  };

  return (
    <>
      {isLoading && <Loader />}

      <div className="card card-custom "  >
        <div className="card-header" style={{ paddingLeft: '0px' }}>
          <h3 className="card-title fw-bold headerTitle pl-0">
            {/* {t('Feature Management')} */}
            {getValueFromResource('Feature Management', dispatch, t)}
          </h3>
          <div className="card-toolbar">
            <a id="btnUpdate"
              className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
              onClick={handleOnClickEvent}>
              {/* {t('Update Feature')} */}
              {getValueFromResource('Update Feature', dispatch, t)}
            </a>
          </div>
        </div>
        <div className="card-body">


          <div className='row'>

            {/* Time Tracking */}

            <div className="col-md-4">
              <div className={`card card-custom card-stretch-50 shadow  mb-6 ${featureManagementList.findIndex((item: any) => item.isSelected == 1 && item.SystemFeatureId.toUpperCase() == 'DB17DEB7-51A0-4400-BF3B-9094E01EF038') > -1 ? 'color-TimeTracking' : ''}`}
                //style={{boxShadow:'0px 0px 3px #bdbdbd'}}
                style={{ border: '1px solid rgba(189, 189, 189, 0.5)' }}
              >
                <div className="card-header d-flex align-items-center justify-content-between px-4" style={{ borderBottom: '1px solid rgba(189, 189, 189, 0.5)' }}>
                  <div className="card-toolbar">
                    <img src={toAbsoluteUrl('/media/svg/features-logos/icon-TimeTracking.svg')} />
                    <h3 className="card-title spacingBetweenIconAndHeading" >{t('Time Tracking')}</h3>
                  </div>
                  <div className="form-check form-switch form-check-custom">
                    <input
                      id="chkTimesheet"
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      checked={featureManagementList.findIndex((item: any) => item.isSelected == 1 && item.SystemFeatureId.toUpperCase() == 'DB17DEB7-51A0-4400-BF3B-9094E01EF038') > -1 ? true : false}
                      onChange={(e) => handleChange(e, 'DB17DEB7-51A0-4400-BF3B-9094E01EF038', 'Timesheet')}
                    />
                  </div>
                </div>
                <div className="card-body px-4" style={{ height: '200px', overflow: 'scroll' }}>
                  <p className="desc"> {t('Manage & track your employees & contractors time with easy to use options which includes Daily/Weekly/Monthly/Semi-Monthly Timesheet, customizable Multi-Level Approval Path, Email Notifications & Reminders, Validations for Minimum/Maximum hours input, Audit Trial, Automatic Timer & various different reports etc.')}
                  </p>
                </div>
              </div>
            </div>

            {/* Expense Tracking */}

            <div className="col-md-4" >
              <div className={`card card-custom card-stretch-50 shadow mb-6 ${featureManagementList.findIndex((item: any) => item.isSelected == 1 && item.SystemFeatureId.toUpperCase() == '537F44E5-EC0F-4DE6-AA29-09450961C5E9') > -1 ? 'color-ExpenseTracking' : ''}`}
                style={{ border: '1px solid rgba(189, 189, 189, 0.5)' }}
              >

                <div className="card-header d-flex align-items-center justify-content-between px-4" style={{ borderBottom: '1px solid rgba(189, 189, 189, 0.5)' }}>
                  <div className="card-toolbar">
                    <img src={toAbsoluteUrl('/media/svg/features-logos/icon-ExpenseTracking.svg')} />
                    <h3 className="card-title spacingBetweenIconAndHeading">{t('Expense Tracking')}</h3>
                  </div>
                  <div className="form-check form-switch form-check-custom">
                    <input
                      id="chkExpenseSheet"
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      checked={featureManagementList.findIndex((item: any) => item.isSelected == 1 && item.SystemFeatureId.toUpperCase() == '537F44E5-EC0F-4DE6-AA29-09450961C5E9') > -1 ? true : false}
                      onChange={(e) => handleChange(e, '537F44E5-EC0F-4DE6-AA29-09450961C5E9', 'Expense')}
                    />
                  </div>
                </div>
                <div className="card-body px-4" style={{ height: '200px', overflow: 'scroll' }}>
                  <p className="desc">{t('Manage expense with easy to use Expense Sheet entry option with variety of different options available which includes customizable Multi-Level Approval Path, Email Notifications & Reminders, Validations, Reimbursement, Multi Currency, Billable/Non-Billable Expenses, Attachments & various different reports etc.')}
                  </p>
                </div>
              </div>
            </div>

            {/* Time-Off Tracking */}

            <div className="col-md-4">
              <div className={`card card-custom card-stretch-50 shadow mb-6 ${featureManagementList.findIndex((item: any) => item.isSelected == 1 && item.SystemFeatureId.toUpperCase() == '76AAF57E-96A4-4476-94A4-575824E9B9FA') > -1 ? 'color-TimeOffTracking' : ''}`}
                style={{ border: '1px solid rgba(189, 189, 189, 0.5)' }}
              >

                <div className="card-header d-flex align-items-center justify-content-between px-4" style={{ borderBottom: '1px solid rgba(189, 189, 189, 0.5)' }}>
                  <div className="card-toolbar">
                    <img src={toAbsoluteUrl('/media/svg/features-logos/icon-Time-OffTracking.svg')} />
                    <h3 className="card-title spacingBetweenIconAndHeading">{t('Time-Off Tracking')}</h3>
                  </div>
                  <div className="form-check form-switch form-check-custom">
                    <input
                      id="chkTimeOff"
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      checked={featureManagementList.findIndex((item: any) => item.isSelected == 1 && item.SystemFeatureId.toUpperCase() == '76AAF57E-96A4-4476-94A4-575824E9B9FA') > -1 ? true : false}
                      onChange={(e) => handleChange(e, '76AAF57E-96A4-4476-94A4-575824E9B9FA', 'Time-Off')}
                    />
                  </div>
                </div>
                <div className="card-body px-4" style={{ height: '200px', overflow: 'scroll' }}>
                  <p className="desc">{t('Manage your leave balances and accruals by setting-up the Time-Off policies with different options which includes customizable Multi-Level Approval Path, Email Notifications & Reminders, Validations, & various different reports etc.')}
                  </p>
                </div>
              </div>
            </div>

            {/* Billing & Invoicing */}

            <div className="col-md-4">
              <div className={`card card-custom card-stretch-50 shadow mb-6 ${featureManagementList.findIndex((item: any) => item.isSelected == 1 && item.SystemFeatureId.toUpperCase() == 'DEAA2AE5-133D-4C8A-AB0C-B89EAA76116E') > -1 ? 'color-BillingInvoicing' : ''}`}
                style={{ border: '1px solid rgba(189, 189, 189, 0.5)' }}
              >

                <div className="card-header d-flex align-items-center justify-content-between px-4" style={{ borderBottom: '1px solid rgba(189, 189, 189, 0.5)' }}>
                  <div className="card-toolbar">
                    <img src={toAbsoluteUrl('/media/svg/features-logos/icon-BillingInvoicing.svg')} />
                    <h3 className="card-title spacingBetweenIconAndHeading">{t('Billing & Invoicing')}</h3>
                  </div>
                  <div className="form-check form-switch form-check-custom">
                    <input
                      id="chkBilling"
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      checked={featureManagementList.findIndex((item: any) => item.isSelected == 1 && item.SystemFeatureId.toUpperCase() == 'DEAA2AE5-133D-4C8A-AB0C-B89EAA76116E') > -1 ? true : false}
                      onChange={(e) => handleChange(e, 'DEAA2AE5-133D-4C8A-AB0C-B89EAA76116E', 'Billing')}
                    />
                  </div>
                </div>
                <div className="card-body px-4" style={{ height: '200px', overflow: 'scroll' }}>
                  <p className="desc">{t('Generate Invoices against your clients for unbilled time & expense entries with different option includes Project / Task / Employee / Project Roles based billing rates with history, custom Logos & Footers, Billed/Unbilled log, customizable multiple taxes with formulas & various different reports etc.')}
                  </p>
                </div>
              </div>
            </div>

            {/* Project Management */}

            <div className="col-md-4">
              <div className={`card card-custom card-stretch-50 shadow mb-6 ${featureManagementList.findIndex((item: any) => item.isSelected == 1 && item.SystemFeatureId.toUpperCase() == '27D3A272-D849-4942-9985-7672FB582389') > -1 ? 'color-ProjectManagement' : ''}`}
                style={{ border: '1px solid rgba(189, 189, 189, 0.5)' }}>

                <div className="card-header d-flex align-items-center justify-content-between px-4" style={{ borderBottom: '1px solid rgba(189, 189, 189, 0.5)' }}>
                  <div className="card-toolbar">
                    <img src={toAbsoluteUrl('/media/svg/features-logos/icon-ProjectManagement.svg')} />
                    <h3 className="card-title spacingBetweenIconAndHeading">{t('Project Management')}</h3>
                  </div>
                  <div className="form-check form-switch form-check-custom">
                    <input
                      id="chkProject"
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      checked={featureManagementList.findIndex((item: any) => item.isSelected == 1 && item.SystemFeatureId.toUpperCase() == '27D3A272-D849-4942-9985-7672FB582389') > -1 ? true : false}
                      onChange={(e) => handleChange(e, '27D3A272-D849-4942-9985-7672FB582389', 'Project')}
                    />
                  </div>
                </div>
                <div className="card-body px-4" style={{ height: '200px', overflow: 'scroll' }}>
                  <p className="desc">{t('Manage your Projects with variety of useful options which includes multi-level Parent / Child Task hierarchy, Milestones, Gantt Chart, Email Notifications & Reminders, Estimations & Budgets, Project & Task Costing & various useful reports for analysis.')}
                  </p>
                </div>
              </div>
            </div>

            {/* Attendance Management */}

            <div className="col-md-4">
              <div className={`card card-custom card-stretch-50 shadow mb-6 ${featureManagementList.findIndex((item: any) => item.isSelected == 1 && item.SystemFeatureId.toUpperCase() == '21E65278-AB96-42C6-A332-16CAFBBC669E') > -1 ? 'color-AttendanceManagement' : ''}`}
                style={{ border: '1px solid rgba(189, 189, 189, 0.5)' }}>

                <div className="card-header d-flex align-items-center justify-content-between px-4" style={{ borderBottom: '1px solid rgba(189, 189, 189, 0.5)' }}>
                  <div className="card-toolbar">
                    <img src={toAbsoluteUrl('/media/svg/features-logos/icon-AttendanceManagement.svg')} />
                    <h3 className="card-title spacingBetweenIconAndHeading">{t('Attendance Management')}</h3>
                  </div>
                  <div className="form-check form-switch form-check-custom">
                    <input
                      id="chkAttendance"
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      checked={featureManagementList.findIndex((item: any) => item.isSelected == 1 && item.SystemFeatureId.toUpperCase() == '21E65278-AB96-42C6-A332-16CAFBBC669E') > -1 ? true : false}
                      onChange={(e) => handleChange(e, '21E65278-AB96-42C6-A332-16CAFBBC669E', 'Attendance')}
                    />
                  </div>
                </div>
                <div className="card-body px-4" style={{ height: '200px', overflow: 'scroll' }}>
                  <p className="desc">{t('Manage your employee’s attendance with simple to use In / Out entry with different reports available for reporting.')}</p>
                </div>
              </div>
            </div>

            {/* Calendar  */}

            <div className="col-md-4" style={{display: 'none'}}>
              <div className={`card card-custom card-stretch-50 shadow mb-6 ${featureManagementList.findIndex((item: any) => item.isSelected == 1 && item.SystemFeatureId.toUpperCase() == '9289F75C-48BE-4002-BEF6-DF8BE6E014CB') > -1 ? 'color-AttendanceManagement' : ''}`}
                style={{ border: '1px solid rgba(189, 189, 189, 0.5)', backgroundColor: 'rgb(103, 38, 109, 0.1)' }}>

                <div className="card-header d-flex align-items-center justify-content-between px-4" style={{ borderBottom: '1px solid rgba(189, 189, 189, 0.5)' }}>
                  <div className="card-toolbar">
                    <img src={toAbsoluteUrl('/media/svg/features-logos/icon-calander.svg')} />
                    <h3 className="card-title spacingBetweenIconAndHeading">{t('Calendar Management')}</h3>
                  </div>
                  <div className="form-check form-switch form-check-custom">
                    <input
                      id="chkAttendance"
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      checked={featureManagementList.findIndex((item: any) => item.isSelected == 1 && item.SystemFeatureId.toUpperCase() == '9289F75C-48BE-4002-BEF6-DF8BE6E014CB') > -1 ? true : false}
                      onChange={(e) => handleChange(e, '9289F75C-48BE-4002-BEF6-DF8BE6E014CB', 'Calendar')}
                    />
                  </div>
                </div>
                <div className="card-body px-4" style={{ height: '200px' }}>
                  <p className="desc">{t('Easily connect your Calendar with Google or Outlook for outbound scheduling and event visibility, export TimeLive entries directly to your connected calendar for a two-way sync.')}</p>
                  <div
                    className="mt-4 p-3 rounded-lg d-flex align-items-center justify-content-between"
                    style={{
                      background: 'rgb(103, 38, 109, 0.1)',
                      border: '1px solid #67266d',
                      borderRadius: '0.275rem',
                      gap: '12px'
                    }}
                  >
                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                      {/* <i className="bi bi-arrow-repeat fs-2 text-dark cursor-pointer" style={{ marginBottom: '8%' }}></i> */}
                      <i className="ki-outline ki-crown-2 fs-1 fw-bold cursor-pointer" style={{ marginBottom: '16%', color: '#67266d' }}></i>
                      <div>
                        <h4 className="mb-0" style={{ fontSize: '14px', fontWeight: 'bold', color: '#1f2937', lineHeight: 1.2 }}>
                          {t('Upgrade to Premium')}
                        </h4>
                        <p className="desc" >
                          {t('Take your scheduling to the next level.')}
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        console.log('upgrade');
                      }}
                      className="btn btn-primary btn-sm text-nowrap px-4"
                    >
                      {t('Upgrade Now')}
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </>
  )
}

export default FeatureManagement

